/******************************************************************************
 * 
 * Strauss Motion
 * 
 * Copyright (c) 2022 Robimo GmbH
 *
 * Authors: Daniel Martinek
 *
 *****************************************************************************/
 import { useState } from 'react';
 import { useTranslation } from 'react-i18next';
import { copyTextToClipboard } from '../helpers/helpers';
 
 import {ReactComponent as IconCopy} from '../icons/copy.svg';
  
  
 import styles from '../styles/code.module.scss'
 
 interface CodeProps {
    code: string|null;
 }
 
 export function Code(props:CodeProps) {
     const {t} = useTranslation();
     const [isCodeCopied, setIsCodeCopied] = useState(false);
 
     return (
        <div className={`${styles.pocketScreenShareContainer} ms-auto`}>
            <p className={`${styles.pocketScreenShare}`}>{t('pocketscreen.share')}</p>
            <input className={`${styles.pocketScreenShareInput}`} type="text" value={`${props.code}`} readOnly={true} />
            <button className={`${styles.pocketScreenShareInputCopyButton}`} onClick={() => {
                copyTextToClipboard(props.code !== null ? props.code : 'No code found')
                .then(() => {
                    setIsCodeCopied(true);
                    setTimeout(() => {
                        setIsCodeCopied(false);
                    }, 1500);
                })
                .catch((err) => {
                    console.log(err);
                });
            }}><IconCopy/></button>
            <p className={`${styles.pocketScreenShared} ${isCodeCopied ? styles.pocketScreenSharedVisible : ''}`}>{t('pocketscreen.shared')}</p>
        </div>
     );
 };
  

